// LocalStorage key for theme settings
const THEME_STORAGE_KEY = 'theme_customizer_settings';

// Default theme settings
const defaultSettings = {
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  sidebarSize: 'lg',
  topbar: 'light',
  mode: 'light',
  position: 'fixed',
  sidebarView: 'default',
  sidebarColor: 'dark',
  sidebarImage: 'none',
  preloader: 'disable',
  visibility: 'show'
};

// Load settings from localStorage
function loadFromStorage() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Merge with defaults to handle any new settings
      return { ...defaultSettings, ...parsed };
    }
  } catch (e) {
    console.error('Failed to load theme settings from localStorage:', e);
  }
  return { ...defaultSettings };
}

// Save settings to localStorage
function saveToStorage(state) {
  try {
    const settings = {
      layoutType: state.layoutType,
      layoutWidth: state.layoutWidth,
      sidebarSize: state.sidebarSize,
      topbar: state.topbar,
      mode: state.mode,
      position: state.position,
      sidebarView: state.sidebarView,
      sidebarColor: state.sidebarColor,
      sidebarImage: state.sidebarImage,
      preloader: state.preloader,
      visibility: state.visibility
    };
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    console.error('Failed to save theme settings to localStorage:', e);
  }
}

// Initialize state from localStorage
export const state = loadFromStorage();

export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
    saveToStorage(state);
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
    saveToStorage(state);
  },
  CHANGE_SIDEBAR_TYPE(state, sidebarSize) {
    state.sidebarSize = sidebarSize;
    saveToStorage(state);
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
    saveToStorage(state);
  },
  CHANGE_MODE(state, mode) {
    state.mode = mode;
    saveToStorage(state);
  },
  CHANGE_POSITION(state, position) {
    state.position = position;
    saveToStorage(state);
  },
  CHANGE_SIDEBAR_VIEW(state, sidebarView) {
    state.sidebarView = sidebarView;
    saveToStorage(state);
  },
  CHANGE_SIDEBAR_COLOR(state, sidebarColor) {
    state.sidebarColor = sidebarColor;
    saveToStorage(state);
  },
  CHANGE_SIDEBAR_IMAGE(state, sidebarImage) {
    state.sidebarImage = sidebarImage;
    saveToStorage(state);
  },
  CHANGE_PRELOADER(state, preloader) {
    state.preloader = preloader;
    saveToStorage(state);
  },
  CHANGE_VISIBILITY(state, visibility) {
    state.visibility = visibility;
    saveToStorage(state);
  },
};

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType);
    document.body.removeAttribute("style");
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth);
  },

  changeSidebarSize({ commit }, { sidebarSize }) {
    commit('CHANGE_SIDEBAR_TYPE', sidebarSize);
  },

  changeTopbar({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar);
  },

  changeMode({ commit }, { mode }) {
    commit('CHANGE_MODE', mode);
  },

  changePosition({ commit }, { position }) {
    commit('CHANGE_POSITION', position);
  },

  changeSidebarView({ commit }, { sidebarView }) {
    commit('CHANGE_SIDEBAR_VIEW', sidebarView);
  },

  changeSidebarColor({ commit }, { sidebarColor }) {
    commit('CHANGE_SIDEBAR_COLOR', sidebarColor);
  },

  changeSidebarImage({ commit }, { sidebarImage }) {
    commit('CHANGE_SIDEBAR_IMAGE', sidebarImage);
  },

  changePreloader({ commit }, { preloader }) {
    commit('CHANGE_PRELOADER', preloader);
  },

  changeVisibility({ commit }, { visibility }) {
    commit('CHANGE_VISIBILITY', visibility);
  }
};
